import { useNavigate } from "react-router-dom";
import LOGO from "../../assets/York-logo-fundobranco.jpg"; // ajuste o caminho se necessário
import { useAuth } from "../../context/authContext";
import useCommentWebSocket from "../../utils/useCommentWebSocket ";

function Home() {
  useCommentWebSocket();
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="w-full bg-gray-50 flex flex-col items-center justify-center px-4 text-gray-800">
      <div className=" w-full bg-white p-4 rounded-lg shadow-md text-center">
        {/* Logo + título */}
        <div className="flex justify-center mb-4">
          <img src={LOGO} alt="Logo York" className="h-12" />
        </div>
        <h1 className="text-3xl font-bold mb-2">{user.username}, seja bem-vindo ao Sistema de Chamados de T.I.</h1>
        <p className="text-gray-600 text-lg mb-6">
          Aqui você pode registrar, acompanhar e resolver suas solicitações com a equipe de tecnologia da informação.
        </p>

        {/* Benefícios */}
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-6 text-left mb-8">
          <div className="bg-gray-100 p-4 rounded-lg">
            <h3 className="text-lg font-semibold mb-1">
              <i className="fas fa-plus-circle text-indigo-600 mr-2" />
              Abertura de Chamados
            </h3>
            <p className="text-sm text-gray-700">
              Registre problemas ou solicitações de suporte técnico rapidamente.
            </p>
          </div>
          <div className="bg-gray-100 p-4 rounded-lg">
            <h3 className="text-lg font-semibold mb-1">
              <i className="fas fa-comments text-indigo-600 mr-2" />
              Acompanhamento em tempo real
            </h3>
            <p className="text-sm text-gray-700">
              Veja atualizações, responda e receba e-mail e notificações sobre seus chamados.
            </p>
          </div>
          <div className="bg-gray-100 p-4 rounded-lg">
            <h3 className="text-lg font-semibold mb-1">
              <i className="fas fa-list-ol text-indigo-600 mr-2" />
              Histórico completo
            </h3>
            <p className="text-sm text-gray-700">
              Consulte todos os seus chamados anteriores a qualquer momento.
            </p>
          </div>
          <div className="bg-gray-100 p-4 rounded-lg">
            <h3 className="text-lg font-semibold mb-1">
              <i className="fas fa-check-circle text-indigo-600 mr-2" />
              Respostas rápidas
            </h3>
            <p className="text-sm text-gray-700">
              A equipe de T.I. responde com agilidade e eficiência.
            </p>
          </div>
        </div>

        {/* CTA */}
        <button
          onClick={() => navigate("/solicitacao")}
          className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-3 rounded-lg text-base font-medium"
        >
          Abrir nova solicitação
        </button>
      </div>
    </div>
  );
}

export default Home;
